var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogoOptimized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.145 10.249a13.69 13.69 0 0 1-3.93 1.056 6.809 6.809 0 0 0 3.001-3.762 13.474 13.474 0 0 1-4.33 1.65 6.808 6.808 0 0 0-4.988-2.158 6.823 6.823 0 0 0-6.824 6.828c0 .529.064 1.057.168 1.565A19.396 19.396 0 0 1 6.169 8.283a6.777 6.777 0 0 0-.929 3.447 6.83 6.83 0 0 0 3.042 5.687 6.884 6.884 0 0 1-3.086-.868v.084a6.827 6.827 0 0 0 5.472 6.7 7.22 7.22 0 0 1-1.797.232 9.07 9.07 0 0 1-1.29-.104 6.837 6.837 0 0 0 6.38 4.735 13.679 13.679 0 0 1-8.473 2.918c-.572 0-1.1-.02-1.649-.084a19.327 19.327 0 0 0 10.483 3.062c12.552 0 19.42-10.398 19.42-19.424 0-.297 0-.593-.02-.889a14.703 14.703 0 0 0 3.423-3.53Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogoOptimized);
export default __webpack_public_path__ + "static/media/twitterLogo-optimized.fa13b645ae14fb1af0f1146a3d7dc1df.svg";
export { ForwardRef as ReactComponent };